import { useMemo } from 'react';

import { useBooleanFeatureFlag } from '@confluence/session-data';

import { getSmartCardOptions } from '../utils/smartCardOptions';

export const useSmartCards = (isChromelessEditor: boolean = false) => {
	const enableDefaultEmbedLoomInlineComments = useBooleanFeatureFlag(
		'confluence.frontend.embed.loom.default.inline.comments',
	);

	const enableChromelessEditorCardProvider =
		isChromelessEditor && enableDefaultEmbedLoomInlineComments;

	return useMemo(() => {
		return getSmartCardOptions(enableChromelessEditorCardProvider);
	}, [enableChromelessEditorCardProvider]);
};
